import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]

  remove({ currentTarget, params: { field } }) {
    const input = this.element.elements.namedItem(`watchdog[${field}]`)
    const item = currentTarget.closest("li")
    const focusTarget = item.nextElementSibling?.querySelector("button") ||
      item.previousElementSibling?.querySelector("button") || this.element.elements.namedItem("watchdog[query]")

    input.value = ["shipping", "personal_handover"].includes(field) ? "0" : ""
    item.remove()
    this.listTarget.hidden = this.listTarget.children.length === 0
    input.dispatchEvent(new Event("input", { bubbles: true }))
    focusTarget.focus()
  }
}
